// test1938
(1938 && 0);
